import {
  DEFAULT_SYS_PROMPT,
  type TtsSource,
  useGlobal,
} from "@/app/providers/use-global";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useScreen } from "@/hooks/use-screen";
import { cn } from "@/lib/utils";
import { SpeakerIcon, Volume2, VolumeX } from "lucide-react";

export const SPEECH_SYS_PROMPT =
  "Respond with short, succinct, and concise results. Never reply with more than 50 words maximum, 25 words is optimal. Replies should be short and friendly in character.";

type Props = {
  triggerClassName?: string;
};

const SpeechSelect = ({ triggerClassName }: Props) => {
  const { ttsSource, setTtsSource, setSystemPrompt } = useGlobal();
  const { isMobile } = useScreen();

  const handleChangeTtsSource = (v: TtsSource) => {
    localStorage.setItem("ttsSource", v);
    if (v === "mute") {
      setSystemPrompt(DEFAULT_SYS_PROMPT);
    } else {
      setSystemPrompt(SPEECH_SYS_PROMPT);
    }
    setTtsSource(v);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className={cn("p-2", triggerClassName)} variant="ghost">
          {ttsSource !== "mute" ? (
            <Volume2 aria-hidden="false" strokeWidth={1.5} />
          ) : (
            <VolumeX aria-hidden="false" strokeWidth={1.5} />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="p-2 flex flex-col gap-2"
        side={isMobile ? "top" : "bottom"}
        align={isMobile ? "end" : "start"}
        sideOffset={10}
      >
        <div className="flex items-center gap-2">
          <SpeakerIcon className="dark:stroke-white" />

          <Select value={ttsSource} onValueChange={handleChangeTtsSource}>
            <SelectTrigger className="w-[120px] dark:border-gray-500 dark:text-foreground">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="mute">Mute</SelectItem>
              <SelectItem value="english">English</SelectItem>
              <SelectItem value="arabic">Arabic</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SpeechSelect;
